import bowser from 'yola-bowser';

const getOffsetTop = (elementRect, scrollPosition, indent) =>
  bowser.ios ? elementRect.top - indent : elementRect.top + scrollPosition - indent;

export default getOffsetTop;
